












import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class ComponentIcon extends Vue {
  @Prop({ default: '', type: String }) readonly path!: string
  @Prop({ default: '24', type: [String, Number] }) readonly size!: string
}
